export function atoz() {

	const azNav = document.getElementById('a-z-nav');
	const aznavLinks = azNav.querySelectorAll('a');
	const href = window.location.hash;

	if (href) {
		toggleActive(azNav.querySelector(`a[href="${href}"]`))
	}

	[].forEach.call(aznavLinks, (link) => {
		link.addEventListener('click', toggleActive, false);
	})

	function toggleActive(e) {
		let el = e.target ? e.target : e;
		[].forEach.call(aznavLinks, (link) => {
			link.classList.remove('is-active');
		})
		el.classList.toggle('is-active');
	}

}